module.exports = __webpack_public_path__ + "static/sailing-58b5f5b4b5dde12d49a92e8878e32bc7.jpg";